export enum PREMIUM_MEDIA_ACTIONS {
    RECEIVE_PREMIUM_MEDIA_STATUS = 'RECEIVE_PREMIUM_MEDIA_STATUS',
    RECEIVE_PREMIUM_MEDIA_USAGE = 'RECEIVE_PREMIUM_MEDIA_USAGE',
}
